const SubAbas = [
  { label: 'Meus Dados', rota: '/fornecedor/meusdados/usuario' },
  { label: 'Meus Acessos', rota: '/fornecedor/meusdados/acessos' },
  /*{ label: 'Meus Logs', rota: '/fornecedor/meusdados/logs' },*/
];

export default SubAbas;
